/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

var ACTIONS_FETCH = 'FETCH';
var ACTIONS_POST = 'POST';
var ACTIONS_FAILURE = 'FAILURE';
var ACTIONS_SUCCESS = 'SUCCESS';
var LIBRARY_ROOT = 'ua-library';
var ROUTE_CHANGED = 'ROUTE_CHANGED';
export { ACTIONS_FETCH, ACTIONS_POST, ACTIONS_FAILURE, ACTIONS_SUCCESS, LIBRARY_ROOT, ROUTE_CHANGED };